import {PhotoCarousel} from "@/components/tour/PhotoCarousel";
import styled from "@emotion/styled";
import {getColor} from "@/styles/ThemeConfig";
import {breakpoints} from "@/styles/sizes";
import YoutubePopup from "@/components/other/YoutubePopup";

const TitleWrapper = styled.div`
    max-width: 100%;
    color: ${getColor('gold')};
    text-transform: uppercase;
    @media only screen and (${breakpoints.mobile}) {
        padding: 0 10px;
    }
    margin-bottom: 10px;
`;

const TourMediaSectionWrapper = styled.div`
    padding:120px 0;
    display: grid;
    grid-template-columns:1fr 1fr;
    align-items: center;
    justify-content: space-between;
    gap:30px;
    
    @media only screen and (${breakpoints.mobile}) {
        align-items: stretch;
        display: flex;
        padding:80px 20px;
        flex-direction: column;
    }
`;

export function getUrlFromatted(videoUrl) {
    const regex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = videoUrl?.match(regex);
    return match ? `https://www.youtube.com/embed/${match[1]}` : videoUrl;
}

export default function TourMediaSection({videoThumbnail, videoTitle,videoSubtitle,videoUrl,imagesTitle,imagesSubtitle,images})
{

    return <div className={'container_small'}>
        {
            ((videoThumbnail && videoUrl) || (images && images?.length > 0)) && <TourMediaSectionWrapper>
                {
                    (videoThumbnail && videoUrl) && <div>
                        <TitleWrapper>
                            {videoTitle && <h2 style={{width: 'fit-content'}} className={'h4'}>{videoTitle}</h2>}
                            {videoSubtitle && <h2 style={{width: 'fit-content', fontWeight: 'bold'}} className={'h4'}>{videoSubtitle}</h2>}
                        </TitleWrapper>


                        <YoutubePopup
                            title={`${videoTitle} ${videoSubtitle}`}
                            thumbnail={videoThumbnail}
                            url={getUrlFromatted(videoUrl)}
                        />
                    </div>
                }

                {
                    (images && images?.length > 0) && <div>
                        <TitleWrapper>
                            {imagesTitle && <h2 style={{width: 'fit-content'}} className={'h4'}>{imagesTitle}</h2>}
                            {imagesSubtitle && <h2 style={{width: 'fit-content', fontWeight: 'bold'}} className={'h4'}>{imagesSubtitle}</h2>}
                        </TitleWrapper>

                        <div style={{
                            maxWidth: '100%',
                            width: '550px',
                            height: '370px',
                            overflow: 'hidden',
                        }}>
                            <PhotoCarousel photos={images}/>
                        </div>
                    </div>
                }

            </TourMediaSectionWrapper>
        }
    </div>

}
